import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b86d5594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = ["checked", "id", "name"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkboxbg" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.checked,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changed'))),
      id: _ctx.checkboxid,
      name: _ctx.checkboxid
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}